'use client';

import useUser from '@alltrails/context/hooks/useUser';
import GoogleOneTap from '@alltrails/layout/components/GoogleOneTap';
import useBraze from '@alltrails/layout/hooks/useBraze';
import useOsano from '@alltrails/layout/hooks/useOsano';
import useTinuitiPixel from '@alltrails/layout/hooks/useTinuitiPixel';
import AmplitudeBrowserSdk from '@alltrails/layout/scripts/AmplitudeBrowserSdk';
import Sprig from '@alltrails/layout/scripts/Sprig';
import { DatadogRumScript } from '@alltrails/stability';
import ReturningUserUpsell from '@alltrails/upsell/components/ReturningUserUpsell/ReturningUserUpsell';
import useAppleRedirectHandler from '@alltrails/user-auth/hooks/useAppleRedirectHandler';
import { useAppSelector } from '@/utils/redux';

const TrailPageAnalytics = () => {
  useOsano();
  useTinuitiPixel();
  useBraze();
  useAppleRedirectHandler();

  const limitReached = useAppSelector(state => state.trailPage.viewLimitReached);
  const user = useUser();

  return (
    <>
      <DatadogRumScript />
      <AmplitudeBrowserSdk logDwellTime />
      <Sprig userId={user?.id} />
      {limitReached !== 'uninitialized' && <GoogleOneTap pageViewLimitReached={limitReached} />}
      <ReturningUserUpsell />
    </>
  );
};

export default TrailPageAnalytics;
